import clsx from 'clsx'
import Link from 'next/link'
import React, { HTMLProps, useState } from 'react'

import { Icon } from '@wartek-id/icon'
import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text'

import { NavigationItem } from './types'

interface PropsVerticalNavigationItem {
  item: NavigationItem
}

const VerticalNavigationItem = ({ item }: PropsVerticalNavigationItem) => {
  const hasActiveChild = item.children
    ?.flatMap((child) => child.children || child)
    .some((child) =>
      child.href ? window.location.pathname.startsWith(child.href) : false
    )
  const [isOpened, setIsOpened] = useState(hasActiveChild)
  const isActive = item.href && window.location.pathname.startsWith(item.href)

  return (
    <li>
      <Link
        href={item.href || '#'}
        target={item.newTab ? '_blank' : undefined}
        className={clsx(
          'flex justify-between items-center p-3 rounded-lg hover:bg-[#FFFFFF1A]',
          isActive && 'bg-[#FFFFFF1A]',
          item.disabled && 'cursor-not-allowed'
        )}
        onClick={(e) => {
          item.onClick?.()

          if (item.disabled || !!item.children?.length) e.preventDefault()
          setIsOpened(!isOpened)
        }}
      >
        <span className="flex items-center gap-3">
          {item.icon && <Icon color="inverse">{item.icon}</Icon>}
          <Text color="inverse">
            {isActive ? <strong>{item.label}</strong> : item.label}
          </Text>
        </span>

        {item.isLoading && <Spinner size="sm" />}

        {!!item.children?.length && (
          <Icon
            color="inverse"
            className={clsx(isOpened && 'rotate-180', 'transition-transform')}
          >
            expand_more
          </Icon>
        )}
      </Link>
      {!!item.children?.length && isOpened && (
        <CustomVerticalNavigation items={item.children} className="ml-8" />
      )}
    </li>
  )
}

interface CustomVerticalNavigation extends HTMLProps<HTMLUListElement> {
  items: NavigationItem[]
}

const CustomVerticalNavigation = ({
  items,
  className,
  ...props
}: CustomVerticalNavigation) => {
  return (
    <ul className={clsx(className, 'p-1 space-y-2')} {...props}>
      {items.map((item) => (
        <VerticalNavigationItem key={item.label} item={item} />
      ))}
    </ul>
  )
}

export default CustomVerticalNavigation
